import React from "react";
import { Controller } from "react-hook-form";
import styles from "./styles.module.scss";
import getValidationRules from "src/validations/ValidationRules";
import { CustomInput, UICheckBox, UIText } from "src/components/uIKit";
import ErrorMessage from "src/components/errorMessage";
import { useAppSelector } from "src/hooks/useRedux";
import { IDS, INPUT_LENGTH } from "src/utils/enums";
import { useOutletContext } from "react-router-dom";

import { getByTitle } from "@testing-library/react";
import ScreenReaderText from "src/components/accessibilityKit/screenReaderText/ScreenReaderText";
interface LoginProps {
  // handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // isChecked: boolean;
}

const Login: React.FC = () => {
  const { strings, loginErrorMessage } = useAppSelector((state) => state.app);
  const validationRules = getValidationRules(strings);
  // const { isChecked, handleCheckboxChange } = useOutletContext<LoginProps>();

  return (
    <div className={styles.infoPart}>
      <ScreenReaderText text={strings.acc_t_login_sub_title} announnceDelay={2100}/>

      <UIText
        text={strings.t_login_sub_title}
        size={22}
        weight={600}
        style={styles.cardTitle}
      />
      <br />
      <Controller
        name="id"
        rules={validationRules.id}
        render={({ field, fieldState: { error } }) => (
          <>
            <UIText
              id={IDS.LOGIN_PERSONAL_ID_LABEL}
              text={strings.t_login_id}
              size={18}
              weight={400}
              style={styles.cardTitle}
            />
            <br />

            <div className={styles.pRelative}>
              <CustomInput
                inputType="id"
                type="tel"
                {...field}
                maxLength={INPUT_LENGTH.ID}
                minLength={INPUT_LENGTH.ID}
                customStyle={styles.inputContainerCustomStyle}
                ariaDescribedBy={IDS.LOGIN_PERSONAL_ID_LABEL}
                {...(error ? { errorDescribedBy: IDS.LOGIN_PERSONAL_ID_ERROR_MESSAGE } : {})}
                autoFocus={true}
              />
              <ErrorMessage id={IDS.LOGIN_PERSONAL_ID_ERROR_MESSAGE} style={styles.error} message={error?.message} />
            </div>
          </>
        )}
      />

      <br />
      <br />

      <Controller
        name="phone"
        rules={validationRules.phone}
        render={({ field, fieldState: { error } }) => (
          <>
            <UIText
              id={IDS.LOGIN_PHONE_LABEL}
              text={strings.t_login_phone}
              size={22}
              weight={600}
              style={styles.cardTitle}
            />
            <br />
            <div className={styles.pRelative}>
              <CustomInput
                inputType="phone"
                type="tel"
                {...field}
                maxLength={INPUT_LENGTH.PHONE}
                minLength={INPUT_LENGTH.PHONE}
                customStyle={styles.inputContainerCustomStyle}
                ariaDescribedBy={IDS.LOGIN_PHONE_LABEL}
                {...(error ? { errorDescribedBy: IDS.LOGIN_PHONE_ERROR_MESSAGE } : {})}
                autoFocus={false}
              />
              <ErrorMessage id={IDS.LOGIN_PHONE_ERROR_MESSAGE} style={styles.error} message={error?.message} />
            </div>
          </>
        )}
      />
      <div className={styles.loginErrorMessageWrapper}>
        <UIText
          text={loginErrorMessage}
          size={16}
          weight={400}
          style={styles.loginError}
        />
      </div>
      <br />
      <br />

      {/* <div className={styles.checkBoxWrapper}>
        <UICheckBox
          text={strings.t_login_checkbox_text}
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <UIText
          text={strings.t_login_checkbox_text_link}
          size={16}
          weight={400}
          style={styles.checkBoxLabel}
        />
      </div> */}
    </div>
  );
};

export default Login;
